export const NA_VALUE = -1;
export const CUL_MAX_LABEL_LENGTH = 100;
